import Setting from '@/page/purchase/Setting';
import Order from '@/page/purchase/Order';
import Stock from '@/page/purchase/Stock';
import Return from '@/page/purchase/Return';
import Query from '@/page/purchase/Query';
import OrderAdd from '@/page/purchase/OrderAdd';
import StockAdd from '@/page/purchase/StockAdd';
import ReturnAdd from '@/page/purchase/ReturnAdd';
import stockDetail from '@/page/purchase/stockDetail';
import orderDetail from '@/page/purchase/orderDetail';
import purchaseReturnDetail from '@/page/purchase/returnDetail';
// import detail from '@/components/template/detail'

export const purchase = [
  {
    path: '/purchase/setting',
    name: 'setting',
    component: Setting,
    meta: {
      requireAuth: true,
      title: '采购业务设置'
    }
  },
  {
    path: '/purchase/order',
    name: 'order',
    component: Order,
    meta: {
      requireAuth: true,
      title: '采购单'
    }
  },
  {
    path: '/purchase/order/add',
    name: 'orderAdd',
    component: OrderAdd,
    meta: {
      requireAuth: true,
      title: '采购单'
    }
  },
  {
    path: '/purchase/order/detail',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      requireAuth: true,
      title: '采购单详情'
    }
  },
  {
    path: '/purchase/stock',
    name: 'stock',
    component: Stock,
    meta: {
      requireAuth: true,
      title: '采购入库单'
    }
  },
  {
    path: '/purchase/stock/add',
    name: 'stockAdd',
    component: StockAdd,
    meta: {
      requireAuth: true,
      title: '采购入库单'
    }
  },
  {
    path: '/purchase/stock/detail',
    name: 'stockDetail',
    component: stockDetail,
    meta: {
      requireAuth: true,
      title: '采购入库单详情'
    }
  },
  {
    path: '/purchase/return',
    name: '采购退货单',
    component: Return,
    meta: {
      requireAuth: true,
      title: '采购退货单'
    }
  },
  {
    path: '/purchase/return/add',
    name: 'returnAdd',
    component: ReturnAdd,
    meta: {
      requireAuth: true,
      title: '采购退货单'
    }
  },
  {
    path: '/purchase/query',
    name: 'query',
    component: Query,
    meta: {
      requireAuth: true,
      title: '采购查询'
    }
  },
  {
    path: '/purchase/return/detail',
    name: 'purchaseReturnDetail',
    component: purchaseReturnDetail,
    meta: {
      requireAuth: true,
      title: '采购退货单详情'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/purchase.route.js